/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean, number as codecNumber } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AbstractRole } from './AbstractRole';
const CourseRoleParser = /* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['courseId', codecNumber, 'course_id'],
    ['hidden', codecBoolean],
]), AbstractRole);
export class CourseRole extends AbstractRole {
    static decode(input) {
        return CourseRoleParser.decode(input).map(res => new CourseRole(res));
    }
    static unsafeDecode(input) {
        return CourseRole.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseRoleParser.encode(data);
    }
    static schema() {
        return CourseRoleParser.schema();
    }
}
